import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UserAvatarComponent } from '../../../shared-module/components/user-avatar/user-avatar.component';
import { TopBarSearchStore } from '../../../shared-module/components/top-bar/top-bar.search.store';
import { TopBarComponent } from '../../../shared-module/components/top-bar/top-bar.component';
import * as Routes from '../../../routes-definitions';

@Component({
	selector: '[layout-top-bar-mobile]',
	templateUrl: './top-bar-mobile.component.html',
	styles: `
        .mobile-tenant-name { max-height: 3em; }
        .user-account { margin-left: 0; }
    `,
	providers: [{ provide: TopBarSearchStore, useValue: {} }],
	imports: [
		UserAvatarComponent,
		NgbDropdownModule,
		NgbTooltipModule,
		TranslateModule,
		RouterModule,
		CommonModule,
	],
})
export class TopBarMobileComponent extends TopBarComponent {

	protected title = inject(Title)

	Routes = Routes
}
